import React, { Component } from 'react';
import { Table, Icon, Row, Button, Modal, message, Input, Select, Popconfirm, Switch, Col } from 'antd';
import moment from "moment";
import './index.scss';
import Auth from "./Auth";
import { inject, observer } from "mobx-react";
import { numConvert } from '../../method';

const Option = Select.Option;
const { confirm } = Modal;

@inject('store')
@observer
class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            loading: true,
            visible: false,
            dataCompared: {
                name: "",
                note: "",
            },
            compared: [],
            loadingSave: false,
            hotel: [],
            hotelTotal: [],
            name: "",
            selectedRowKeys: [],
            dataGroup: []
        }
    }

    componentDidMount() {
        this.getData();
        fetch('/getHeadquartersHotels', { credentials: 'include' }).then(x => x.json()).then(x => {
            if (x.status == 1) {
                this.setState({
                    hotel: x.data.hotels || [],
                    hotelTotal: x.data.hotels || [],
                    dataGroup: x.data.group || []
                });
                return
            }
            message.error('数据获取失败！' + JSON.stringify(x.msg))
        }).catch(err => {
            console.error(err);
            message.error('数据获取失败！' + JSON.stringify(err))
        });
    }

    getData = () => {
        this.setState({ loading: true });
        fetch('/getEComGroup', { credentials: 'include' }).then(x => x.json()).then(x => {
            this.setState({ loading: false });
            if (x.status == 1) {
                this.setState({ data: (x.data.group || []).reverse(), compared: x.data.compared || [] });
                return
            }
            message.error('数据获取失败！' + JSON.stringify(x.msg))
        }).catch(err => {
            this.setState({ loading: false });
            console.error(err);
            message.error('数据获取失败！' + JSON.stringify(err))
        })
    }

    onDelete = (id) => {
        fetch('/deleteEGroup?id=' + id, { credentials: 'include' }).then(x => x.json()).then(x => {
            if (x.status == 1) {
                message.info('删除成功！');
                this.getData();
                return
            }

            message.error(x.msg);
        }).catch(err => {
            console.error(err);
        })
    }

    showModal = () => {
        this.setState({ visible: true });

    }

    handleOk = () => {
        this.setState({ loadingSave: true });
        const that = this;
        let { compared, dataCompared, selectedRowKeys } = this.state;
        let data = dataCompared;
        data.hotels = selectedRowKeys.toString();

        // 筛选是否全是同一类型，m_为每日经营报表月度汇总  内容包含daily
        const isAllDay = compared.every(x => x.sqlName.includes('daily') && !x.sqlName.includes('m_'));



        if (!data.name) {
            message.error('请输入表格标题！');
            that.setState({ loadingSave: false });
            return
        }
        if (data.hotels.length <= 0) {
            message.error('请选择酒店！');
            that.setState({ loadingSave: false });
            return
        }

        if (compared.length <= 0 && !data.id) {
            message.error('已添加数据为零，无法保存！');
            that.setState({ loadingSave: false });
            return
        }

        if (isAllDay) {
            confirm({
                title: '请选择保存月度还是每日报表?',
                content: '选中的表格中包括每日报表，与月度报表冲突，请选择保存！',
                okText: "保存月度报表",
                cancelText: "保存每日报表",
                onOk() {
                    save('month');
                },
                onCancel() {
                    save('day');
                },
            });
        } else {
            save('month');
        }

        function save(type = "month") {
            data.add_time = moment().format('YYYY-MM-DD HH:mm:ss');
            data.type = type;

            let headres = {
                method: 'post',
                credentials: 'include',
                headers: {},
                body: JSON.stringify(data),
            }
            fetch('/addEGroup', headres).then(x => x.json()).then(x => {
                that.setState({ loadingSave: false });
                if (x.status == 1) {
                    message.info('保存成功！');
                    that.setState({ visible: false, selectedRowKeys: [], compared: { name: "", note: "" } });
                    that.getData();
                    return
                }

                message.error('保存失败！');
            }).catch(err => {
                that.setState({ loadingSave: false });
                console.error(err);
            })
        }
    }

    render() {
        const columns = [{
            title: '名称',
            dataIndex: 'name',
            key: 'name',
        }, {
            title: '备注',
            dataIndex: 'note',
            key: 'note',
        }, {
            title: '添加时间',
            dataIndex: 'add_time',
            key: 'add_time',
        }, {
            title: '操作',
            key: '操作',
            render: (record) => {
                return (
                    <div>
                        <span
                            style={{ color: "#1890ff", cursor: "pointer" }}
                            onClick={() => {
                                this.setState({
                                    dataCompared: { ...record },
                                    visible: true,
                                    selectedRowKeys: record.hotels.split(',').map(x => numConvert(x))
                                });
                            }}
                        >编辑</span>
                        <Icon type="minus" />
                        <span
                            style={{ color: "#1890ff", cursor: "pointer" }}
                            onClick={() => {
                                if (record.type && record.type == 'day') {
                                    this.props.history.push(`/table/compared/daydetail/${record.id}`);
                                    return
                                }
                                this.props.history.push(`/table/compared/detail/${record.id}`);
                            }}
                        >查看</span>
                        <Icon type="minus" />
                        <Popconfirm
                            title="确定要删除这个表格?"
                            onConfirm={() => {
                                this.onDelete(record.id);
                            }}
                            onCancel={() => { }}
                            okText="是"
                            cancelText="否"
                        >
                            <span style={{ color: "#1890ff", cursor: "pointer" }} >删除</span>
                        </Popconfirm>

                    </div>
                )
            }
        }];

        // 酒店列表
        const columnsHotel = [{
            title: '酒店名称',
            dataIndex: 'name',
            key: 'name',
        }, {
            title: '联系人',
            dataIndex: 'contacts',
            key: 'contacts',
        }, {
            title: '地址',
            dataIndex: 'address',
            key: 'address',
        }, {
            title: '联系电话',
            key: 'tel',
            dataIndex: 'tel',
        }];

        const rowSelection = {
            selectedRowKeys: this.state.selectedRowKeys,
            onChange: (key, selectedRows) => {
                this.setState({ selectedRowKeys: key });
            },
        };

        const data = this.state.data;
        const dataCompared = this.state.dataCompared;
        return (
            <Auth>
                <div className='compared'>
                    <Row style={{ fontSize: 18, color: "#333" }}>
                        Executive Summary Report 月度经营报告
                    </Row>
                    <Row style={{ margin: '20px 0' }}   >
                        <span>
                            表格自定义开关 ：
                            <Switch
                                checkedChildren="开"
                                unCheckedChildren="关"
                                checked={this.props.store.compared.state}
                                onChange={checked => {
                                    this.props.store.compared.onChange(checked);
                                }}
                            />
                        </span>
                        <Button
                            type="primary"
                            style={{ float: "right" }}
                            onClick={() => {
                                this.props.history.push('/bp/hotelgroup');
                            }}
                        >
                            酒店分组管理
                        </Button>
                    </Row>
                    <Table
                        style={{ marginTop: 20 }}
                        columns={columns}
                        dataSource={data}
                        bordered
                        loading={this.state.loading}
                        rowKey={item => item.id}
                    />

                    <Row style={{ textAlign: "right", marginTop: 20 }}>
                        <Button
                            type="primary"
                            onClick={() => {
                                this.props.history.goBack();
                            }}
                        >
                            返回
                        </Button>
                        <Button
                            type="primary"
                            style={{ marginLeft: 10 }}
                            onClick={() => {
                                this.showModal();
                            }}
                        >
                            保存
                        </Button>
                    </Row>
                    <Modal
                        title="自定义表格"
                        visible={this.state.visible}
                        onOk={this.handleOk}
                        onCancel={() => this.setState({ visible: false, dataCompared: {} })}
                        className="compared-modal"
                        footer={[
                            <Button key="back" onClick={() => this.setState({ visible: false })}>取消</Button>,
                            <Button key="submit" type="primary" loading={this.state.loadingSave} onClick={this.handleOk}>
                                保存
                            </Button>,
                        ]}
                    >
                        <Row>
                            <Col span={12}>
                                <span>表格标题：</span>
                                <Input
                                    value={dataCompared.name}
                                    className="compared-input"
                                    onChange={(e) => {
                                        let data = this.state.dataCompared;
                                        data.name = e.target.value || "";
                                        this.setState({
                                            dataCompared: data
                                        });
                                    }}
                                />
                            </Col>
                            <Col span={12} >
                                <span>备注：</span>
                                <Input
                                    value={dataCompared.note}
                                    className="compared-input"
                                    style={{ marginLeft: 28 }}
                                    onChange={(e) => {
                                        let data = this.state.dataCompared;
                                        data.note = e.target.value || "";
                                        this.setState({
                                            dataCompared: data
                                        });
                                    }}
                                />
                            </Col>
                        </Row>
                        {/* <DetailModal data={this.state.compared}></DetailModal> */}
                        <Row style={{ marginTop: 20 }}>
                            <Col span={12}>
                                <span>酒店名称：</span>
                                <Input
                                    style={{ width: 200, marginRight: 10 }}
                                    value={this.state.name}
                                    onChange={(e) => {
                                        this.setState({
                                            name: (e.target.value || "").trim()
                                        });
                                    }}
                                />
                                <Button
                                    type="primary"
                                    onClick={() => {
                                        let hotelTotal = this.state.hotelTotal;
                                        let name = this.state.name;
                                        let hotel = hotelTotal.filter(x => x.name.includes(name));
                                        this.setState({
                                            hotel
                                        });

                                    }}
                                >搜索</Button>
                            </Col>
                            <Col span={12}>
                                <span  >快捷选择酒店：</span>
                                <Select
                                    showSearch
                                    allowClear
                                    style={{ width: 200 }}
                                    placeholder="选择酒店分组"
                                    optionFilterProp="children"
                                    onChange={value => {
                                        let selectedRowKeys = value ? value.split(',').map(x => Number(x)) : [];

                                        this.setState({ selectedRowKeys });
                                    }}
                                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                >
                                    {(this.state.dataGroup || []).map(x => {
                                        return (
                                            <Option key={x.hotels}>{x.name}</Option>
                                        )
                                    })}
                                </Select>
                            </Col>
                        </Row>
                        <Row style={{ marginTop: 20 }}>
                            已选酒店{this.state.selectedRowKeys.length || "0"}家，已添加数据{this.state.compared.length || "0"}条
                        </Row>
                        <Table
                            style={{ marginTop: 10 }}
                            columns={columnsHotel}
                            dataSource={this.state.hotel}
                            bordered
                            className="hotelModal"
                            rowSelection={rowSelection}
                            rowKey={item => item.id}
                        />

                    </Modal>
                </div>
            </Auth >
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/compared/index.js